/** Pure helpers for the layout chrome (no React components — keeps fast-refresh happy). */
import type { User } from '@/types/api';

/** Format a count for a badge, capping the display at `99+`. */
export function formatCount(n: number): string {
  return n > 99 ? '99+' : String(n);
}

/** Best-effort initials for a user's avatar fallback. */
export function userInitials(
  user: Pick<User, 'firstname' | 'lastname'> | null | undefined
): string {
  if (!user) return '?';
  const a = user.firstname?.[0] ?? '';
  const b = user.lastname?.[0] ?? '';
  const initials = `${a}${b}`.trim();
  return initials ? initials.toUpperCase() : '?';
}
